/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";

import { ProductPageHero } from "../blocks/Hero/ProductPageHero";
import { SearchFormLanding } from "../blocks/SearchForm/SearchFormLanding";
import { productTypePackage } from "../constants/productTypes";

export const DealerPackagesPage: FunctionComponent = () => {
  return (
    <>
      <ProductPageHero />
      <SearchFormLanding productType={productTypePackage} />
    </>
  );
};
